import { useTranslation } from 'react-i18next';
import { useAlert } from 'shared/components/alerts';
import { useRenderDocument } from './use-render-document';

export const useDisplayDocument = (documentId: string) => {
  const { t } = useTranslation('web-common');
  const { refetch } = useRenderDocument(documentId, { enabled: false });
  const { alertError } = useAlert();

  const handleDownload = async () => {
    try {
      const response = await refetch();
      const url = response.data?.url;

      if (url) {
        window.open(url, '_blank');
      } else {
        alertError(new Error(t('documents.alerts.download_error', { ns: 'web-common' })));
      }
    } catch (err: any) {
      alertError(err);
    }
  };

  return { handleDownload };
};
